import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isAuthed } from './PasswordPage';

export default function RequireAuth() {
  const location = useLocation();
  if (!isAuthed()) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
